import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LangContext";
import { Button } from "@/components/ui/button";
import { Globe, ExternalLink } from "lucide-react";
import { openBooking } from "@/lib/booking";

export function Logo({ className = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="logo-link">
      <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center overflow-hidden shadow-sm ring-1 ring-black/5">
        <img src="/taf-logo.jpg" alt="TAF" className="w-full h-full object-contain p-0.5" />
      </div>
      <span className="font-display font-black text-lg sm:text-xl tracking-tight text-foreground leading-none" style={{ letterSpacing: "0.01em" }}>
        TAF<span className="text-primary"> </span>VILLAS<span className="text-primary"> </span>PADEL
      </span>
    </Link>
  );
}

export default function Header() {
  const { lang, toggle } = useLang();

  return (
    <header className="fixed top-0 w-full z-50 glass border-b">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Logo />
        <div className="flex items-center gap-2 sm:gap-3">
          <button
            onClick={toggle}
            data-testid="lang-toggle"
            className="flex items-center gap-1.5 text-sm font-bold text-muted-foreground hover:text-primary transition-colors"
          >
            <Globe className="w-4 h-4" /> {lang.toUpperCase()}
          </button>
          <Button
            onClick={openBooking}
            data-testid="header-book-btn"
            className="rounded-full bg-primary text-primary-foreground font-bold hover:opacity-90 inline-flex items-center gap-1.5"
          >
            Book on Playtomic <ExternalLink className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
